module.exports = __webpack_public_path__ + "static/img/好物分销.4fd8c812.png";